import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export interface SectionEntryRowProps {
  /** Start icon on the action button — a visual cue for the destination. */
  icon: React.ReactNode;
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
}

/**
 * One browse-style entry inside a section card (e.g. "Browse the full catalog",
 * the cleanup wizard). Borderless — the enclosing `PracticeSectionCard` owns the
 * border and separates rows with dividers.
 */
export const SectionEntryRow: React.FC<SectionEntryRowProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
}) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', md: '1fr auto' },
      gap: 2,
      alignItems: 'center',
    }}
  >
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 680 }}>
        {description}
      </Typography>
    </Box>
    <Button
      variant="outlined"
      startIcon={icon}
      onClick={onAction}
      sx={{ justifySelf: { xs: 'stretch', md: 'end' } }}
    >
      {actionLabel}
    </Button>
  </Box>
);
